import { baseSepolia, hardhat, mainnet } from 'wagmi/chains'
import { isHexAddress } from '@/lib/utils'
import LOCAL_ADDRESSES from '@/constants/contract-addresses/local'
import BASE_SEPOLIA_ADDRESSES from '@/constants/contract-addresses/base-sepolia'
import MAINNET_ADDRESSES from '@/constants/contract-addresses/mainnet'

export type ContractName =
    | 'playerRegistry'
    | 'kycRegistry'
    | 'operator'
    | 'operatorRoles'
    | 'referralManager'
    | 'potSeeder'
    | 'draw'
    | 'quickGame'

type AddressMap = Record<number, Record<ContractName, `0x${string}` | undefined>>

function addr(value: string | undefined): `0x${string}` | undefined {
    return value !== undefined && isHexAddress(value) ? value : undefined
}

// Addresses come from the per-chain TS files under src/constants/contract-addresses/,
// which `scripts/sync-addresses.mjs` rewrites from ../blockpot-contracts (local) or
// the Railway CHAINS_CONFIG blob (hosted). See the Dockerfile's STAGING sync step.
function pick(source: {
    [key: string]: `0x${string}`
}): Record<ContractName, `0x${string}` | undefined> {
    return {
        playerRegistry: addr(source.playerRegistry),
        kycRegistry: addr(source.kycRegistry),
        operator: addr(source.operator),
        operatorRoles: addr(source.operatorRoles),
        referralManager: addr(source.referralManager),
        potSeeder: addr(source.potSeeder),
        draw: addr(source.draw),
        quickGame: addr(source.quickGame),
    }
}

export const CONTRACT_ADDRESSES: AddressMap = {
    [hardhat.id]: pick(LOCAL_ADDRESSES),
    [baseSepolia.id]: pick(BASE_SEPOLIA_ADDRESSES),
    [mainnet.id]: pick(MAINNET_ADDRESSES),
}

export function getContractAddress(chainId: number, name: ContractName): `0x${string}` | undefined {
    return CONTRACT_ADDRESSES[chainId]?.[name]
}
